'use client';

import { useIsClient } from 'usehooks-ts';

import { MoonIcon, SunIcon } from '@/components/ui/Icons/Icons';
import { useTheme } from '@/providers/ThemeProvider/ThemeProvider';

import * as S from './ThemeSwitcher.styles';

export const ThemeSwitcher = () => {
  const isClient = useIsClient();
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  if (!isClient) {
    return <S.Skeleton data-testid="theme-switcher-skeleton" />;
  }

  return (
    <S.SwitcherWrapper
      onClick={toggleTheme}
      aria-label="Theme switcher"
      data-testid="theme-switcher"
      $isDarkMode={theme === 'dark'}
    >
      <S.IconsWrapper $isDarkMode={theme === 'dark'}>
        <SunIcon />
        <MoonIcon />
      </S.IconsWrapper>
      <S.SwitcherCircle $isDarkMode={theme === 'dark'} />
    </S.SwitcherWrapper>
  );
};
